import { _ as _objectSpread2 } from '../../_rollupPluginBabelHelpers-a38db067.js';
import { defaultBreakpoints, getMedias } from '../utils.js';
import { get, merge, sort } from './core-utils.js';

/**
 * Parses responsive objects based on breakpoints and the provided sx function.
 *
 * @param medias - An object of breakpoint values.
 * @param sx - The sx function to apply to values.
 * @param raw - The raw object containing responsive values.
 * @param props - The props object.
 * @returns The parsed responsive styles.
 */
function parseResponsiveObject(medias, sx, raw, props) {
  let styles = {};
  Object.keys(raw).forEach(key => {
    const media = medias[key];
    const value = raw[key];
    const style = sx(value, {}, props);
    if (!media) {
      styles = _objectSpread2(_objectSpread2({}, styles), style);
    } else {
      styles = _objectSpread2(_objectSpread2({}, styles), {
        [media]: _objectSpread2(_objectSpread2({}, styles[media]), style)
      });
    }
  });
  return styles;
}
/**
 * Creates a parser function based on the provided configuration.
 *
 * @param config - The configuration object for the parser.
 * @returns The created parser function.
 */
const createParser = config => {
  const cache = {};
  const parser = props => {
    var _props$theme;
    let styles = {};
    let shouldSort = false;
    const isCacheDisabled = (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.disableStyledSystemCache;
    Object.keys(props).forEach(key => {
      if (!config[key]) {
        return;
      }
      const sx = config[key];
      const raw = props[key];
      if (typeof raw === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get(props.theme, 'breakpoints', defaultBreakpoints);
        if (raw !== null) {
          styles = merge(styles, parseResponsiveObject(getMedias(cache.breakpoints), sx, raw, props));
          shouldSort = true;
        }
        return;
      }
      styles = _objectSpread2(_objectSpread2({}, styles), sx(raw, props));
    });
    if (shouldSort) {
      styles = sort(styles);
    }
    return styles;
  };
  parser.config = config;
  parser.propNames = Object.keys(config);
  parser.cache = cache;
  const keys = Object.keys(config).filter(k => !['config', 'propNames', 'cache'].includes(k));
  if (keys.length > 1) {
    keys.forEach(key => {
      parser[key] = createParser({
        [key]: config[key]
      });
    });
  }
  return parser;
};

export { createParser };
